/* eslint-disable react/prop-types */
import React, { useState, useContext } from 'react';
import { logo, uploadSurvey } from '../../context/Utils';
import { Context } from '../../context/Context';
import { AppContext, Brands } from '../../context/interfaces';
import { BRAND } from 'shared/utils';
import { ReactComponent as CheckmarkSVG } from '../../assets/icons/checkmark_success.svg';
import { SurveyPayload } from 'types/survey';
import { Rating } from '@material-ui/lab';
import SurveyAgent from 'assets/icons/Agente.png';
import { ReactComponent as SurveyMarker } from 'assets/icons/marker_VI.svg';
import { ReactComponent as Survey99 } from 'assets/icons/99_VI.svg';
import SMSurvey from '../survey/forms/SMSurvey';
import { surveyReviewGTM } from 'shared/utils/gooogleTagManager';

import '../../assets/styles/screens/success/Success.scss';

const SuccessScreen = (): JSX.Element => {
	const context = useContext(Context) as AppContext;
	const { eventId } = context;
	const [surveySubmitted, setSurveySubmitted] = useState(false);

	const handleSurveySubmit = async (data: SurveyPayload): Promise<void> => {
		if (eventId) {
			const body: SurveyPayload = {
				inspectionId: eventId,
				comment: data.comment,
				recommend: data.recommend,
				experience: data.experience,
				indInconvenient: data.indInconvenient,
				inconvenient: data.inconvenient,
				agentGrade: data.agentGrade,
			};

			if (body.experience > 0 || body.recommend > 0 || data.comment.trim().length > 0) {
				await uploadSurvey(body);
				surveyReviewGTM(context, data.experience, data.recommend);
			}
		}
		setSurveySubmitted(true);
	};

	return (
		<div className="success-screen">
			<div className="container">
				<div className="icons">
					<img src={logo} alt="logo" className="icons__logo" />
				</div>
				<div className="checkmark-wrapper">
					<CheckmarkSVG className="checkmark" />
				</div>
				<SuccessMessage eventId={eventId} />
			</div>
			{!surveySubmitted && (
				<OptionalSurvey onSubmit={handleSurveySubmit} />
			)}
		</div>
	);
};

interface OptionalSurveyProps {
	onSubmit: (data: SurveyPayload) => void;
}

const OptionalSurvey: React.FC<OptionalSurveyProps> = ({ onSubmit }) => {
	const [recommend, setRecommend] = useState<number | null>(null);
	const [experience, setExperience] = useState<number | null>(null);
	const [agentGrade, setAgentGrade] = useState<number | null>(null);
	const [comment, setComment] = useState<string>('');
	const [indInconvenient, setIndInconvenient] = useState<string>('');
	const [inconvenient, setInconvenient] = useState<string>('');
	const [isVisible, setIsVisible] = useState<boolean>(true);

	const handleChange = (value: string) => {
		if (value === 'Si') setIsVisible(false);
		if (value === 'No') setIsVisible(true);
		setIndInconvenient(value);
	};

	const handleChangeRecommended = (value: number) => {
		setRecommend(Number(value));
	};

	const handleFormSubmit = () => {
		onSubmit({
			recommend: Number(recommend),
			comment: comment,
			experience: Number(experience),
			inconvenient: inconvenient,
			indInconvenient: indInconvenient,
			inspectionId: 0,
			agentGrade: agentGrade === null ? 0 : agentGrade,
		});
	};

	return (
		<div className="success-survey">
			<div className="success-survey__header">
				<h2>Cuéntanos tu experiencia</h2>
				<p className="success-survey__time">(⏱ 1 min)</p>
			</div>
			<form onSubmit={(e) => { e.preventDefault(); handleFormSubmit(); }}>
				{BRAND !== Brands.SEGUROS_MUNDIAL && BRAND !== Brands.COMFENALCO && (
					<>
						<div className="rate-examples">
							<div className="rate-example">
								<Rating value={1} readOnly size="large" />
								<span className="rate-label">= Pobre</span>
							</div>
							<div className="rate-example">
								<Rating value={5} readOnly size="large" />
								<span className="rate-label">= Excelente</span>
							</div>
						</div>

						<div className="question-card">
							<div className="question-card__content">
								<p className="question__text">¿Cómo calificarías tu experiencia con esta aplicación?</p>
								<Rating
									name="experience"
									value={experience}
									size="large"
									onChange={(event: React.ChangeEvent<{}>, newValue: number | null) => {
										setExperience(newValue);
									}}
								/>
							</div>
							<div className="question-card__image">
								<SurveyMarker />
							</div>
						</div>

						<div className="question-card">
							<div className="question-card__content">
								<p className="question__text">¿Cómo calificarías al coordinador de servicio?</p>
								<Rating
									name="agentGrade"
									value={agentGrade}
									size="large"
									onChange={(event: React.ChangeEvent<{}>, newNote: number | null) => {
										setAgentGrade(newNote);
									}}
								/>
							</div>
							<div className="question-card__image">
								<img src={SurveyAgent} alt="agent" />
							</div>
						</div>
					</>
				)}

				{(BRAND === Brands.SEGUROS_MUNDIAL || BRAND === Brands.COMFENALCO) && (
					<SMSurvey
						handleChange={handleChange}
						handleChangeRecommended={handleChangeRecommended}
						inconvenient={inconvenient}
						setInconvenient={setInconvenient}
						setExperience={setExperience}
						isVisible={isVisible}
					/>
				)}
				{BRAND !== Brands.SEGUROS_MUNDIAL && BRAND !== Brands.COMFENALCO && (
					<div className="question-card">
						<div className="question-card__content">
							<p className="question__text">¿Cuán probable es que nos recomiende a un amigo o familiar?</p>
							<Rating
								name="recommend"
								value={recommend}
								size="large"
								onChange={(event: React.ChangeEvent<{}>, newValue: number | null) => {
									setRecommend(newValue);
								}}
							/>
						</div>
						<div className="question-card__image">
							<Survey99 />
						</div>
					</div>
				)}

				<div className="question--comment">
					<p className="question__text">Comentarios adicionales:</p>
					<textarea rows={5} value={comment} onChange={(e) => setComment(e.target.value)}></textarea>
				</div>

				<button type="submit" className="confirm-button">
					Enviar
				</button>
			</form>
		</div>
	);
};

const SuccessMessage: React.FC<{ eventId: number | null }> = (props) => {
	switch (BRAND) {
		case Brands.CSM:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Referencia:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							¿Tienes dudas sobre tu reclamo? Contáctanos al <br />
							<a href="tel:7877580101">787.758.0101</a>
						</p>
					</div>
				</>
			);
		case Brands.LAFISE:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Número de expediente:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>Puedes continuar con tu viaje, te llegará un correo de Seguros LAFISE con los próximos pasos.</p>
						<p>Para contactarnos: 800-523-4732 / 2246-2700</p>
					</div>
				</>
			);
		case Brands.OCEANICA:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Número de expediente:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>Puedes continuar con tu viaje y te llegará un correo de MNK seguros con los próximos pasos.</p>
						<p>Teléfono: 800-289-4546 / 4102-7600</p>
					</div>
				</>
			);
		case Brands.ASSA:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Número de expediente:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							¿Tienes dudas sobre tu reclamo? Contáctenos en horario de 8:00 am – 5:00 pm.
						</p>
						<p>Teléfono: 800-ASSA(2772)</p>
					</div>
				</>
			);
		case Brands.IS_CR:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Número de expediente:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							¿Tienes dudas sobre tu reclamo? Contáctenos en horario de 8:00 am – 5:00 pm.
						</p>
						<p>IS Internacional de Seguros</p>
					</div>
				</>
			);
		case Brands.SEGUROS_MUNDIAL:
		case Brands.COMFENALCO:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Referencia:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							¿Tienes dudas? Contáctanos al <br />
							<a href="tel:6014321661">601.432.1661</a>
						</p>
					</div>
				</>
			);
		case Brands.PURDY:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Número de expediente:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							¿Tienes dudas sobre tu reclamo? Contáctenos en horario de 8:00 am – 5:00 pm.
						</p>
						<p>Teléfono: 800-PURDY (78739)</p>
					</div>
				</>
			);
		case Brands.QUALITAS:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Número de expediente:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>¿Tienes dudas sobre tu reclamo? Contáctanos al número</p>
						<p>800-Quálitas (7825-4827)</p>
					</div>
				</>
			);
		case Brands.INS:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Número de expediente:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>¿Tienes dudas sobre tu reclamo? Contáctanos.</p>
					</div>
				</>
			);
		case Brands.MULTINATIONAL:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Referencia:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							¿Tienes dudas? Contáctanos al <br />
							<a href="tel:7872003584">787-200-3584</a>
						</p>
					</div>
				</>
			);
		case Brands.PREMIER:
		case Brands.SODA:
		case Brands.OPTIMA:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Referencia:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							¿Tienes dudas? Contáctanos al <br />
							<a href="tel:+17877052535">787.705.2535</a>
						</p>
					</div>
				</>
			);
		default:
			return (
				<>
					<h1>¡Inspección completada!</h1>
					<p>Tu solicitud está siendo procesada.</p>
					<p>Número de expediente:</p>
					<h1>#{props.eventId}</h1>
					<div className="contact-us">
						<p>
							¿Tienes dudas sobre tu reclamo? Contáctenos en horario de 8:00 am – 5:00 pm.
						</p>
						<p>Teléfono: 800-7872 y WhatsApp: 6328-7872</p>
					</div>
				</>
			);
	}
};

export default SuccessScreen;
